import React from 'react';
const NotFoundPage = () => {
    return (
        <React.Fragment>
            <div style={{
            textAlign:'center',
            fontSize: '30px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%'
        }}>
            <p style={{
                textAlign:'center',
                fontSize: '30px',
                color: 'red'
            }}>
                404 Not Found
            </p>
        </div>
        </React.Fragment>
    );
}
export default NotFoundPage;
